function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { DATA } from '@wix/component-protocol/schema';
import { isSameEditorPointer } from './ManifestRuntimeContextBuilder';
import { createEditorPlatformManifestServicesError, EditorPlatformManifestServicesErrorCode } from '../errors';
import { getEditorPointerUniqueId } from '../getEditorPointerUniqueId';
var _ManifestQuery_brand = /*#__PURE__*/new WeakSet();
export class ManifestQuery {
  constructor(api, runtimeManifestContext, isReadonly) {
    if (isReadonly === void 0) {
      isReadonly = false;
    }
    this.api = api;
    this.runtimeManifestContext = runtimeManifestContext;
    this.isReadonly = isReadonly;
    _classPrivateMethodInitSpec(this, _ManifestQuery_brand);
  }
  readonly() {
    return new ManifestQuery(this.api, this.runtimeManifestContext, true);
  }
  getChildren() {
    return this.runtimeManifestContext.tree.children.map(child => {
      return new ManifestQuery(this.api, {
        ...this.runtimeManifestContext,
        tree: child
      }, this.isReadonly);
    });
  }

  /**
   * editorPointer is null for a root element,
   * since root context might be built from the multiple components
   */
  getEditorPointer() {
    return this.runtimeManifestContext.tree.editorPointer;
  }
  getExtensionType() {
    return this.runtimeManifestContext.tree.extensionType;
  }
  async getData() {
    const data = [];
    const childEditorPointer = this.runtimeManifestContext.tree.editorPointer;
    const queryManifests = childEditorPointer ? [{
      editorPointer: childEditorPointer,
      extensionType: this.runtimeManifestContext.manifests[0].store.extensionType
    }] : this.runtimeManifestContext.manifests.map(x => ({
      editorPointer: x.editorPointer,
      extensionType: x.store.extensionType
    }));
    const mappings = this.runtimeManifestContext.tree.mappings.data;
    data.push(...(await Promise.all(queryManifests.map(async _ref => {
      let {
        editorPointer,
        extensionType
      } = _ref;
      const _data = await this.api.data.getData(editorPointer, extensionType);
      if (!_data) {
        return null;
      }
      return _assertClassBrand(_ManifestQuery_brand, this, _getRuntimeItems).call(this, editorPointer, _data, mappings);
    }))));
    const allData = data.filter(x => !!x).reduce((acc, _data) => {
      return {
        ...acc,
        ..._data
      };
    }, {});
    return _assertClassBrand(_ManifestQuery_brand, this, _fillWithDefaultValues).call(this, allData, this.runtimeManifestContext.tree.mappings.data, this.api.data.getDefaultValue.bind(this.api.data));
  }
  async getResolvedData(_ref2) {
    var _this$runtimeManifest;
    let {
      dataItemKey
    } = _ref2;
    const definition = (_this$runtimeManifest = this.runtimeManifestContext.tree.manifest.editorElement) == null || (_this$runtimeManifest = _this$runtimeManifest.data) == null ? void 0 : _this$runtimeManifest[dataItemKey];
    if (!definition) {
      return;
    }
    switch (definition.dataType) {
      case DATA.DATA_TYPE.vectorArt:
        {
          const allData = await this.getData();
          const vectorArtData = allData[dataItemKey];
          return this.api.resolvedData.getVectorArtResolvedData(vectorArtData);
        }
      default:
        {
          console.warn(createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ManifestQuery, `"${definition.dataType}" is not supported yet for resolving`));
          return;
        }
    }
  }
  async setData(values) {
    if (!values) {
      return;
    }
    if (this.isReadonly) {
      throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ManifestQuery, 'query instance is readonly');
    }
    if (!Object.keys(values).length) {
      return;
    }
    const _values = _assertClassBrand(_ManifestQuery_brand, this, _mapRuntimeKeys).call(this, Object.keys(values), this.runtimeManifestContext.tree.mappings.data, (runtimeKey, originalKey, currentValue) => {
      return {
        ...currentValue,
        [originalKey]: values[runtimeKey]
      };
    });
    console.log('data values to set into dm', _values);
    await Promise.all(_values.map(context => {
      return this.api.data.setData(context.editorPointer, context.extensionType, context.value);
    }));
  }
  async getStyles() {
    const styles = [];
    const childEditorPointer = this.runtimeManifestContext.tree.editorPointer;
    const queryManifests = childEditorPointer ? [{
      editorPointer: childEditorPointer,
      extensionType: this.runtimeManifestContext.manifests[0].store.extensionType
    }] : this.runtimeManifestContext.manifests.map(x => ({
      editorPointer: x.editorPointer,
      extensionType: x.store.extensionType
    }));
    styles.push(...(await Promise.all(queryManifests.map(async _ref3 => {
      let {
        editorPointer,
        extensionType
      } = _ref3;
      const _styles = await this.api.styles.getStyles(editorPointer, extensionType);
      if (!_styles) {
        return null;
      }
      const cssProperties = _styles.cssProperties ? _assertClassBrand(_ManifestQuery_brand, this, _getRuntimeItems).call(this, editorPointer, _styles.cssProperties, this.runtimeManifestContext.tree.mappings.cssProperties) : {};
      const cssCustomProperties = _styles.cssCustomProperties ? _assertClassBrand(_ManifestQuery_brand, this, _getRuntimeItems).call(this, editorPointer, _styles.cssCustomProperties, this.runtimeManifestContext.tree.mappings.cssCustomProperties) : {};
      return {
        cssProperties,
        cssCustomProperties
      };
    }))));
    const allStyles = styles.filter(x => !!x).reduce((acc, _styles) => {
      return {
        cssProperties: {
          ...acc.cssProperties,
          ..._styles.cssProperties
        },
        cssCustomProperties: {
          ...acc.cssCustomProperties,
          ..._styles.cssCustomProperties
        }
      };
    }, {
      cssProperties: {},
      cssCustomProperties: {}
    });
    return {
      cssProperties: _assertClassBrand(_ManifestQuery_brand, this, _fillWithDefaultValues).call(this, allStyles.cssProperties, this.runtimeManifestContext.tree.mappings.cssProperties, this.api.styles.getDefaultCssPropertyValue.bind(this.api.styles)),
      cssCustomProperties: _assertClassBrand(_ManifestQuery_brand, this, _fillWithDefaultValues).call(this, allStyles.cssCustomProperties, this.runtimeManifestContext.tree.mappings.cssCustomProperties, this.api.styles.getDefaultCustomCssPropertyValue.bind(this.api.styles))
    };
  }
  async setStyles(values) {
    if (this.isReadonly) {
      throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ManifestQuery, 'query instance is readonly');
    }
    const cssProperties = values.cssProperties ? _assertClassBrand(_ManifestQuery_brand, this, _mapRuntimeKeys).call(this, Object.keys(values.cssProperties), this.runtimeManifestContext.tree.mappings.cssProperties, (runtimeKey, originalKey, currentValue) => {
      return {
        ...currentValue,
        cssProperties: {
          ...(currentValue == null ? void 0 : currentValue.cssProperties),
          [originalKey]: values.cssProperties[runtimeKey]
        },
        cssCustomProperties: {}
      };
    }) : [];
    const cssCustomProperties = values.cssCustomProperties ? _assertClassBrand(_ManifestQuery_brand, this, _mapRuntimeKeys).call(this, Object.keys(values.cssCustomProperties), this.runtimeManifestContext.tree.mappings.cssCustomProperties, (runtimeKey, originalKey, currentValue) => {
      return {
        ...currentValue,
        cssCustomProperties: {
          ...(currentValue == null ? void 0 : currentValue.cssCustomProperties),
          [originalKey]: values.cssCustomProperties[runtimeKey]
        },
        cssProperties: {}
      };
    }) : [];
    const _values = {};
    [...cssProperties, ...cssCustomProperties].forEach(config => {
      const idx = `${getEditorPointerUniqueId(config.editorPointer)}_${config.extensionType}`;
      if (!_values[idx]) {
        _values[idx] = {
          editorPointer: config.editorPointer,
          extensionType: config.extensionType,
          value: {
            cssProperties: {},
            cssCustomProperties: {}
          }
        };
      }
      Object.assign(_values[idx].value.cssProperties, {
        ...config.value.cssProperties
      });
      Object.assign(_values[idx].value.cssCustomProperties, {
        ...config.value.cssCustomProperties
      });
    });
    console.log('style values to set into dm', Object.values(_values));
    await Promise.all(Object.values(_values).map(context => {
      return this.api.styles.setStyles(context.editorPointer, context.extensionType, context.value);
    }));
  }
  async removeStyles(values) {
    if (this.isReadonly) {
      throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ManifestQuery, 'query instance is readonly');
    }
    const cssProperties = values.cssPropertiesKeys ? _assertClassBrand(_ManifestQuery_brand, this, _mapRuntimeKeys).call(this, values.cssPropertiesKeys, this.runtimeManifestContext.tree.mappings.cssProperties, (runtimeKey, originalKey, currentValue) => {
      return {
        ...currentValue,
        cssPropertiesKeys: [...((currentValue == null ? void 0 : currentValue.cssPropertiesKeys) ?? []), originalKey],
        cssCustomPropertiesKeys: []
      };
    }) : [];
    const cssCustomProperties = values.cssCustomPropertiesKeys ? _assertClassBrand(_ManifestQuery_brand, this, _mapRuntimeKeys).call(this, values.cssCustomPropertiesKeys, this.runtimeManifestContext.tree.mappings.cssCustomProperties, (runtimeKey, originalKey, currentValue) => {
      return {
        ...currentValue,
        cssCustomPropertiesKeys: [...((currentValue == null ? void 0 : currentValue.cssCustomPropertiesKeys) ?? []), originalKey],
        cssPropertiesKeys: []
      };
    }) : [];
    const _values = {};
    [...cssProperties, ...cssCustomProperties].forEach(config => {
      const idx = `${getEditorPointerUniqueId(config.editorPointer)}_${config.extensionType}`;
      if (!_values[idx]) {
        _values[idx] = {
          editorPointer: config.editorPointer,
          extensionType: config.extensionType,
          value: {
            cssPropertiesKeys: [],
            cssCustomPropertiesKeys: []
          }
        };
      }
      _values[idx].value.cssPropertiesKeys.push(...config.value.cssPropertiesKeys);
      _values[idx].value.cssCustomPropertiesKeys.push(...config.value.cssCustomPropertiesKeys);
    });
    console.log('style values to remove into dm', Object.values(_values));
    await Promise.all(Object.values(_values).map(context => {
      return this.api.styles.removeStyles(context.editorPointer, context.extensionType, context.value);
    }));
  }
  async getAppliedPreset() {
    const editorPointer = this.runtimeManifestContext.manifests[0].editorPointer;
    const extensionType = this.runtimeManifestContext.manifests[0].store.extensionType;
    return this.api.presets.getAppliedPreset(editorPointer, extensionType);
  }
  applyBreakpointStyleOverrides(editorPointer, type, styleOverrides) {
    const {
      cssProperties,
      cssCustomProperties,
      elements
    } = styleOverrides;
    const mappedCssPropertiesOverrides = Object.fromEntries(Object.entries(cssProperties ?? {}).map(_ref4 => {
      let [key, {
        value
      }] = _ref4;
      return [key, value];
    }));
    const mappedCssCustomPropertiesOverrides = Object.fromEntries(Object.entries(cssCustomProperties ?? {}).map(_ref5 => {
      let [key, {
        value
      }] = _ref5;
      return [key, value];
    }));
    if (Object.keys(mappedCssPropertiesOverrides).length || Object.keys(mappedCssCustomPropertiesOverrides).length) {
      this.setStyles({
        cssProperties: mappedCssPropertiesOverrides,
        cssCustomProperties: mappedCssCustomPropertiesOverrides
      });
    }

    // TODO: [EP-6733] Apply state overrides

    if (elements) {
      _assertClassBrand(_ManifestQuery_brand, this, _applyInnerElementsStyleOverrides).call(this, editorPointer, elements);
    }
  }
  applyPreset(_ref6) {
    var _this$runtimeManifest2, _this$runtimeManifest3;
    let {
      key: presetKey
    } = _ref6;
    const context = (_this$runtimeManifest2 = this.runtimeManifestContext.tree.mappings.presets[presetKey]) == null ? void 0 : _this$runtimeManifest2[0];
    if (!context) {
      return;
    }
    const presetDefinition = (_this$runtimeManifest3 = this.runtimeManifestContext.tree.manifest.editorElement) == null || (_this$runtimeManifest3 = _this$runtimeManifest3.presets) == null ? void 0 : _this$runtimeManifest3[presetKey];
    if (!presetDefinition) {
      console.error('no preset found', presetKey, context);
      return;
    }

    // TODO: should we validate presetKey exist in manifest?
    // TODO: Make sure all actions are done in a single transaction - to mobile as well (to make history undo/redo make all changes at once)

    this.api.presets.applyPreset(context.editorPointer, context.extensionType, presetKey);

    // TODO: [https://wix.atlassian.net/browse/EP-6552] set style overrides (per breakpoint)
    const {
      default: defaultStyleOverrides,
      ..._breakpointStyles
    } = presetDefinition.styleOverrides ?? {};
    if (defaultStyleOverrides) {
      this.applyBreakpointStyleOverrides(context.editorPointer, context.extensionType, defaultStyleOverrides);
    }

    // TODO: [https://wix.atlassian.net/browse/EP-6552] set style overrides (per breakpoint)
    // Object.entries(breakpointStyles).forEach(
    //   ([breakpoint, styleOverrides]) => {
    //     const editorPointer = buildBreakpointEditorPointer(context.editorPointer, breakpoint);
    //     this.#applyBreakpointStyleOverrides(
    //       editorPointer,
    //       context.extensionType,
    //       styleOverrides,
    //     );
    //   },
    // );

    const componentInitialSize = presetDefinition.initialSize;
    if (componentInitialSize && !context.editorPointer.innerElementPath) {
      this.api.layout.applyComponentResize(context.editorPointer, context.extensionType, componentInitialSize);
    }
    return;
  }
  getState() {
    const editorPointer = this.runtimeManifestContext.manifests[0].editorPointer;
    const extensionType = this.runtimeManifestContext.manifests[0].store.extensionType;
    return this.api.state.getState(editorPointer, extensionType);
  }
  setState(state) {
    if (state) {
      var _this$runtimeManifest4;
      const context = (_this$runtimeManifest4 = this.runtimeManifestContext.tree.mappings.states[state]) == null ? void 0 : _this$runtimeManifest4[0];
      if (!context) {
        return;
      }
      this.api.state.setState(context.editorPointer, context.extensionType, state ? state : null);
    } else {
      Object.keys(this.runtimeManifestContext.tree.mappings.states).forEach(key => {
        var _this$runtimeManifest5;
        const context = (_this$runtimeManifest5 = this.runtimeManifestContext.tree.mappings.states[key]) == null ? void 0 : _this$runtimeManifest5[0];
        if (!context) {
          return;
        }
        this.api.state.setState(context.editorPointer, context.extensionType, state ? state : null);
      });
    }
    return;
  }
  activateVisibilityState() {
    var _this$runtimeManifest6;
    const manifest = this.runtimeManifestContext.tree.manifest;
    const inlineElement = manifest;
    const visibleState = inlineElement.visibleState;
    if (!(visibleState != null && visibleState.stateKey) || !(visibleState != null && visibleState.elementPath)) {
      return;
    }
    const {
      stateKey,
      elementPath
    } = visibleState;
    const stateContext = (_this$runtimeManifest6 = this.runtimeManifestContext.tree.mappings.states[stateKey]) == null ? void 0 : _this$runtimeManifest6[0];
    if (!stateContext) {
      return;
    }
    const parentPointer = {
      ...stateContext.editorPointer,
      innerElementPath: elementPath === 'root' ? [] : elementPath.split('.')
    };
    this.api.state.setState(parentPointer, stateContext.extensionType, stateKey);
  }
}
function _getRuntimeItems(editorPointer, items, mappings) {
  return Object.keys(items).reduce((acc, key) => {
    // TODO: try optimize and pre-save reversed mappings.
    const runtimeItemIds = Object.keys(mappings).filter(runtimeItemId => {
      return mappings[runtimeItemId].some(config => {
        return config.key === key && isSameEditorPointer(config.editorPointer, editorPointer);
      });
    });
    if (!runtimeItemIds.length || runtimeItemIds.length > 1) {
      console.error(createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ManifestResolvingError, 'error mapping stored item to the runtime item'));
      return acc;
    }
    const runtimeItemId = runtimeItemIds[0];
    const value = items[key];
    return {
      ...acc,
      [runtimeItemId]: value
    };
  }, {});
}
function _mapRuntimeKeys(keys, mappings, cb) {
  const _values = {};
  [...new Set(keys)].forEach(key => {
    var _mappings$key;
    (_mappings$key = mappings[key]) == null || _mappings$key.forEach(item => {
      const idx = `${getEditorPointerUniqueId(item.editorPointer)}_${item.extensionType}`;
      if (!_values[idx]) {
        _values[idx] = {
          editorPointer: item.editorPointer,
          extensionType: item.extensionType,
          value: undefined
        };
      }
      _values[idx].value = cb(key, item.key, _values[idx].value);
    });
  });
  return Object.values(_values);
}
function _fillWithDefaultValues(data, mappings, getDefaultValue) {
  const _data = {
    ...data
  };
  Object.keys(mappings).forEach(runtimeKey => {
    const config = mappings[runtimeKey][0];
    const originalKey = config.key;
    if (typeof _data[runtimeKey] === 'undefined') {
      const defaultValue = getDefaultValue(config.editorPointer, config.extensionType, originalKey);
      if (defaultValue) {
        _data[runtimeKey] = defaultValue;
      }
    }
  });
  return _data;
}
function _applyInnerElementsStyleOverrides(editorPointer, elements) {
  const children = this.getChildren();
  Object.entries(elements).forEach(_ref7 => {
    let [elementKey, elementStyleOverrides] = _ref7;
    const {
      elements: innerElements,
      presetKey,
      cssProperties,
      cssCustomProperties
    } = elementStyleOverrides;
    const innerElementPath = [...(editorPointer.innerElementPath ?? ['root']), elementKey];
    const childManifestQuery = children.find(child => {
      var _childEditorPointer$i;
      const childEditorPointer = child.getEditorPointer();
      if (!childEditorPointer) {
        return false;
      }
      return ((_childEditorPointer$i = childEditorPointer.innerElementPath) == null ? void 0 : _childEditorPointer$i.length) === innerElementPath.length && childEditorPointer.innerElementPath.every((path, index) => path === innerElementPath[index]);
    });
    if (!childManifestQuery) {
      console.error(createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ManifestQuery, `Missing child ${innerElementPath.join('.')}`));
      return;
    }
    if (presetKey) {
      childManifestQuery.applyPreset({
        key: presetKey
      });
    }
    if (cssProperties || cssCustomProperties) {
      childManifestQuery.applyBreakpointStyleOverrides(childManifestQuery.getEditorPointer(), childManifestQuery.getExtensionType(), {
        cssProperties,
        cssCustomProperties,
        elements: innerElements
      });
    }
  });
}
//# sourceMappingURL=ManifestQuery.js.map